<template>
    <section class="py-6">
        <div class="container">
            <div class="grid lg:grid-cols-[1.05fr_0.95fr] gap-4 bg-grayBg border border-gray-200 rounded-2xl p-2">

                <!-- LEFT -->
                <div class="relative overflow-hidden rounded-xl min-h-[420px] bg-[length:4px] bg-[url('@img/patterns/dot.webp'),radial-gradient(circle,rgba(255,255,255,0.92)_0%,rgba(248,250,252,0.9)_40%,rgba(245,247,251,0.7)_100%)]">

                    <!-- круги -->
                    <div class="absolute inset-[-180px_-90px]
                        [background:repeating-radial-gradient(circle,transparent_0,transparent_42px,rgba(255,186,0,0.35)_43px,transparent_45px)]">
                    </div>

                    <!-- контент -->
                    <div class="relative flex flex-col items-center justify-center h-full text-center px-6">
                        <h2 class="text-[clamp(30px,4vw,44px)] font-extrabold text-gray-900 leading-tight">
                            Почему работать<br>с нами выгодно
                        </h2>
                    </div>

                    <!-- стрелки -->
                    <span class="absolute text-baseColor text-4xl font-light top-[100px] left-[140px]">↘</span>
                    <span class="absolute text-baseColor text-4xl font-light top-[100px] right-[120px]">↙</span>
                    <span class="absolute text-baseColor text-4xl font-light bottom-[100px] left-[140px]">↗</span>
                    <span class="absolute text-baseColor text-4xl font-light bottom-[100px] right-[120px]">↖</span>
                </div>

                <!-- RIGHT -->
                <div class="grid grid-cols-2 md:grid-cols-3 gap-2">

                    <div v-for="item in items"
                         :key="item.title"
                         class="flex flex-col justify-between p-4 rounded-xl bg-[#e4e9f1] min-h-[200px]
                                hover:shadow-md transition">

                        <div>
                            <div class="text-xl font-extrabold mb-2" v-html="item.title"></div>
                            <div class="text-sm font-medium leading-tight" v-html="item.text"></div>
                        </div>

                        <component :is="item.icon" class="w-10 h-10 text-gray-900" />
                    </div>

                </div>

            </div>
        </div>
    </section>
</template>

<script setup>
import IconRubleLayers from "@js/components/Icons/IconRubleLayers.vue";
import IconFirePercent from "@js/components/Icons/IconFirePercent.vue";
import IconUserInShot from "@js/components/Icons/IconUserInShot.vue";
import IconFolders from "@js/components/Icons/IconFolders.vue";
import IconHeadPhones from "@js/components/Icons/IconHeadPhones.vue";
import IconBook from "@js/components/Icons/IconBook.vue";

const items = [
    {
        title: '2-3',
        text: 'Дополнительных<br>предложения по<br>каждой заявке',
        icon: IconRubleLayers,
    },
    {
        title: 'до 15%',
        text: 'Экономии<br>на закупках',
        icon: IconFirePercent,
    },
    {
        title: '★★★★★',
        text: 'Рейтинг<br>поставщиков',
        icon: IconUserInShot,
    },
    {
        title: 'ЭДО',
        text: 'Обменивайтесь<br>значимыми<br>электронными<br>документами',
        icon: IconFolders,
    },
    {
        title: 'Техподдержка',
        text: 'Ответит на вопросы<br>с 08:00 до 20:00<br>по МСК',
        icon: IconHeadPhones,
    },
    {
        title: 'Обучение',
        text: 'Доступно бесплатно<br>всем клиентам',
        icon: IconBook,
    },
];
</script>
